import classnames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';

import { listerClickThrough } from '../../../actions/lister-actions';
import { useIsSmallAndAbove } from '../../../hooks/mediaQueries';
import { useIsProductInHighDemand } from '../../../hooks/useIsProductInHighDemand';
import Image from '../../Generic/Image/Image';

const GetImage = ({ src, ImageAltText, State, ColourId }) => {
	const isSkuHighDemand = useIsProductInHighDemand({ ColourId });

	const isSmallAndAbove = useIsSmallAndAbove();

	const imageDimension = isSmallAndAbove ? '200px' : '100px';

	return (
		<Image
			src={src}
			alt={ImageAltText}
			classes={classnames('product-card__primary-image', {
				'opacity-50': State === 'OutOfStock' || isSkuHighDemand,
			})}
			skeletonProps={{ height: imageDimension }}
			errorSize="large"
		/>
	);
};

const ProductImage = ({
	Image: src,
	ImageAltText,
	FullProductUrl,
	Code,
	State,
	ColourId,
}) => {
	const dispatch = useDispatch();

	const isSmallAndAbove = useIsSmallAndAbove();

	if (isSmallAndAbove && FullProductUrl) {
		return (
			<a
				href={FullProductUrl}
				onClick={(event) => {
					event.preventDefault();
					window.location.assign(FullProductUrl);

					dispatch(listerClickThrough(Code));
				}}
				className="block mx-auto"
				style={{ minHeight: '1px', maxHeight: '200px', maxWidth: '200px' }}
				itemProp="url"
				data-testid="product-image-link">
				<GetImage {...{ src, ImageAltText, State, ColourId }} />
			</a>
		);
	}

	return <GetImage {...{ src, ImageAltText, State, ColourId }} />;
};

export default ProductImage;
